import { useModuleBEM } from "@b2bportal/core-themes";
import { SliceDirection } from "@b2bportal/core-types";
import {
  RebookFlightSlice,
  useRebookSegmentSelection,
} from "@tenant/flights-rebook";
import { RadioGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./RebookSegmentSelection.module.scss";
import type { RebookSegmentSelectionProps } from "./types";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookSegmentSelection;

export const RebookSegmentSelection = (props: RebookSegmentSelectionProps) => {
  const { className, children } = props;
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useRebookSegmentSelection(props);

  return (
    <div className={clsx(block, className)}>
      <RadioGroup
        className={cn("radio-group")}
        selectedOption={context.selectedSegmentId}
        onSelectValue={handlers.selectSegment}
      >
        {context.slices.flatMap(({ slice, segments }, index) => (
          <RebookFlightSlice
            key={index}
            className={cn("slice")}
            slice={slice}
            travelersCount={context.travelersCount}
            airlines={context.airlines}
            airports={context.airports}
            segments={segments}
            direction={
              index === 0 ? SliceDirection.Outbound : SliceDirection.Return
            }
          />
        ))}
      </RadioGroup>
      {children}
    </div>
  );
};
